import { XCircleIcon } from '@heroicons/react/20/solid'

/**
 * Get sign in error.
 * @param {*} code Code from Firebase
 * @returns Error message for this feedback
 */
function getErrorMessage(code) {
    const msgs = {
        'auth/invalid-email': 'Please enter a valid email.',
        'auth/wrong-password': 'Incorrect email or password entered.',
        'auth/user-not-found': 'Incorrect email or password entered.'
    };
    const value = msgs[code];
    return typeof value === 'undefined' ? code : value;
}

function FeedbackMessage(props) {
    return (
        <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">Sign In Errors</h3>
                    <div className="mt-2 text-sm text-red-700">
                        <ul role="list" className="list-disc space-y-1 pl-5">
                            <li>{getErrorMessage(props.error.code)}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeedbackMessage;